import Service from "../../../api/api-service";
import { ApiUrl } from "../../../api/api-url";

const service = new Service();

// Danh mục dự án, trạng thái dự án, hình thức đầu tư dùng chung bộ action, chỉ khác tiền tố
export const InvestmentMasterKind = {
  Category: ApiUrl.InvestmentProjectCategory,
  Status: ApiUrl.InvestmentProjectStatus,
  Type: ApiUrl.InvestmentType,
};

export const GetListMaster = (kind) => service.get(kind + "/GetList");

export const GetDetailMaster = (kind, id) =>
  service.get(kind + "/GetDetail", "id=" + id);

export const CreateMaster = (kind, body) => service.post(kind + "/Create", body);

export const UpdateMaster = (kind, id, body) =>
  service.postParams(kind + "/Update", "id=" + id, body);

export const DeleteMaster = (kind, id) =>
  service.postParams(kind + "/Delete", "id=" + id);
